import * as e from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/ShieldWarning.es.js";
const o = e.forwardRef((r, n) => /* @__PURE__ */ e.createElement(a, { ref: n, ...r, weights: i }));
o.displayName = "ShieldWarningIcon";
const c = o;
export {
  c as ShieldWarning,
  o as ShieldWarningIcon
};
